import { TParticipantInviteForUserMap } from '../PartyClientResponse';

export interface IAppState {
  debug: boolean;
  temporaryUnmute: boolean;
  invites: TParticipantInviteForUserMap;
}
export const initialState: IAppState = {
  debug: false,
  temporaryUnmute: false,
  invites: {},
};

export type IAction =
  | { type: 'set-debug' }
  | { type: 'set-invites'; invites: TParticipantInviteForUserMap };

export const appReducer = (state: IAppState = initialState, action: IAction): IAppState => {
  switch (action.type) {
    case 'set-invites':
      return {
        ...state,
        invites: action.invites,
      };
    case 'set-debug':
      return {
        ...state,
        debug: !state.debug,
      };
    default:
      console.log('Action Type not recognized: ' + JSON.stringify(action));
      return { ...state };
  }
};

export const toggleDebug = (): IAction => {
  return {
    type: 'set-debug',
  };
};

export const setInvites = (invites: TParticipantInviteForUserMap): IAction => {
  return {
    type: 'set-invites',
    invites,
  };
};

export interface IReduxActions {
  toggleDebug: () => IAction;
}

export const AppActions = { toggleDebug };

export const AppMapProps = ({ debug, temporaryUnmute, invites }: IAppState) => ({
  debug,
  temporaryUnmute,
  invites,
});
